<script lang="ts" setup>
const emit = defineEmits(['closeDialog'])

function clickAction() {
  emit('closeDialog')
  const connectBtn = document.querySelector('.connect-btn') as HTMLElement
  if (connectBtn) {
    connectBtn.click()
  }
}
</script>

<template>
  <app-dialog class="connect-from-stake-dialog">
    <div class="title">
      <i-app-wallet-link />
      <span class="text-2xl">Connect your wallet</span>
    </div>
    <div class="desc text-base text-center">
      Please connect your wallet to continue with your stake. Your progress is saved, and you'll pick up right where you left off.
    </div>

    <div class="square-block">
      <app-btn variant="outline" size="lg" @click="clickAction">
        Connect your wallet
      </app-btn>
    </div>
  </app-dialog>
</template>

<style lang="scss">
.connect-from-stake-dialog {
  .q-dialog__body {
    padding: 40px;
    width: 448px;

    @media (max-width: $breakpoint-xs) {
      padding: $space-60 $space-60 $space-80;
    }

    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: calc($border-radius-xl * 2);
      font-weight: 500;
      color: $black;

      @media (max-width: $breakpoint-xs) {
        font-size: 20px;
        gap: $space-xxl;
      }

      svg {
        width: 80px;
        height: 80px;
        color: $zinc-700;

        @media (max-width: $breakpoint-xs) {
          width: 64px;
          height: 64px;
        }
      }
    }

    .desc {
      color: $zinc-400;
      padding: $space-60 0 calc($space-60 * 2);

      @media (max-width: $breakpoint-xs) {
        padding: $space-50 0 $space-80;
        font-size: 16px;
        font-weight: 400;
        line-height: 162.5%;
        letter-spacing: -0.16px;
      }
    }

    .q-btn {
      width: 100%;
    }
  }
}
</style>
